var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('vxe-button',_vm._g(_vm._b({staticClass:"vxe-button-edit-render",attrs:{"content":_vm.text},on:{"click":_vm.onClick}},'vxe-button',_vm.$vxeBtn.props,false),_vm.$vxeBtn.events)):_c('span',{staticClass:"btn-placeholder",on:{"click":_vm.onError}},[_vm._v("🔘")])
}
var staticRenderFns = []

export { render, staticRenderFns }